import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    //remove any case of base href from url
    if (url.split('/')[1]?.toLowerCase() === 'tarifrechner') {
      const segmentArr = url.split('/');
      segmentArr.splice(1, 1);
      url = segmentArr.join('/');
    }
    //Take extra care if the url contains queryParams
    const parts = url.split('?');
    if (parts.length > 1) {
      return super.parse(parts[0].toLowerCase() + `?${parts[1]}`);
    }
    return super.parse(url.toLowerCase());
  }
}
